<template>
  <div class="uv-card">
    <div class="uv-card-body">
      <ModuleHeader>Tipos lineas de crédito</ModuleHeader>
      <uvDataTable
        :config="config"
        :data="tipos"
        :pageRows="15"
        @buttonClick="dtButtonClick"
      ></uvDataTable>
    </div>
    <modal ref="modalForm" :fullscreen="false" v-model="Dialogs.showModal" :showFooter="false">
      <TipoCreditoForm
        :edit="editMode"
        :key="formIndex"
        @toggle="toggleModal"
        :dataEdit="editData"
        @successData="successData"
        />
    </modal>
  </div>
</template>



<script>
import uvDataTable from "../../MainComponents/DataTable.vue";
import TipoCreditoForm from "../TiposCredito/TiposCreditoForm.vue";
import { mapGetters } from "vuex";
export default {
  name: "TiposCreditoCRUD",
  components: {
    uvDataTable,
    TipoCreditoForm
  },
  data() {
    return {
      formIndex: 0,
      editMode: false,
      editData: {},
      indexComponent: 1,
      Dialogs:{
        sync:false,
        showModal: false,
      },
      dataLineas:[],
      config: {
        selectableRow: true,
        orderByCol:{Field:"ncdt",Type:"Asc"},
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addTipoLinea",
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editarTipoLinea",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "softDeleteTipoLinea",
            require: true,
          },
        ],
        fields: [
          {
            text:'Nombre',
            value:'nam',
          },
          {
            value:'con',
            text: "Comportamiento",
          },
        ],
      },
      Catalogos:{
        PlanesMembresias:[],
        data_membresias:[],
      },
      aux:{
        membresiaToSync:{},
      },

    };
  },
  computed: {
    ...mapGetters("dataLists",["getBNK_LineasCredito"]),
    ...mapGetters("LineasCredito",["getTiposCredito","getComportamientos"]),
    lineasCredito(){
      /*let data = JSON.parse(JSON.stringify(this.getBNK_LineasCredito));
      data.forEach((el)=>{
        let cliente = this.$pgsHelper.getById(this.$store.getters.getClientes,'id',el.clnt);
        el.cliente = cliente;
        el.clienteName = cliente.Apellidos +' '+ cliente.Nombres;
      })*/
      return [];
    },
    tipos(){
      let tipos = [];
      this.getTiposCredito.forEach((ele)=>{
        ele.con = this.$pgsHelper.getById(this.getComportamientos,"id",ele.coi).text
        tipos.push(ele);
      })
      return tipos;
    },
    clients() {
      let clientes = {};
      let rowclientes = this.$store.getters.getClientes;
      rowclientes.forEach((element) => {
        if (element.id != "PUBLICOGENERAL") {
          clientes[element.id]=element;
        }
      });
      return clientes;
    },
  },
  methods: {
    successData(data, doAction) {
      if (doAction == "CREATE") {
        this.createLineaCredito(data);
      } else if (doAction == "EDIT") {
        this.editarLineaCredito(data);
      }
    },
    dtButtonClick(buttonId, idSelected) {
      this.formIndex++;
      if (buttonId == "addTipoLinea") {
        this.idSelected = "";
        this.editMode = false;
        this.editData = {};
        this.$refs.modalForm.setTitle("Agregar Tipo de linea de crédito");
        this.clientAdd = {
          nombre: "",
          apellidos: "",
          correo: "",
          telefono: "",
          grupo: "",
        };
        this.toggleModal(true);
      }
      if (buttonId == "editarTipoLinea") {
        this.idSelected = idSelected[0];
        const membresia = this.$pgsHelper.getById(
          this.tipos,
          "id",
          idSelected[0]
        );
        this.editMode = true;
        this.editData = membresia;
        this.$refs.modalForm.setTitle("Linea de Crédito");
        this.toggleModal(true);
      }
      if (buttonId == "softDeleteTipoLinea") {
        this.softDeleteLineaCredito(idSelected[0]);
      }
    },
    validateClientForm() {
      let valid = true;
      if (this.clientAdd.nombre == "") {
        valid = false;
      }

      if (this.clientAdd.apellidos == "") {
        valid = false;
      }

      if (this.clientAdd.email == "") {
        valid = false;
      }

      return valid;
    },
    syncBiometric(){
      this.aux.membresiaToSync;
      this.Dialogs.sync = false;
    },
    createLineaCredito(data) {
      this.$alert.alertConfirm(
        {
          action:"guardar",
          obj:"el tipo linea de crédito",
          route:'BNK-TiposLineaCredito-createTipoLineaCredito',
          data:data,
          onSuccess:()=>{
            this.toggleModal(false);
            this.$store.dispatch("LineasCredito/getTiposCredito");
          }
        }
      );
    },
    editarLineaCredito(data) {
      this.$alert.alertConfirm(
        {
          action:"editar",
          obj:"el tipo linea de crédito",
          route:'BNK-TiposLineaCredito-updateTipoLineaCredito',
          data:data,
          onSuccess:()=>{
            this.toggleModal(false);
            this.$store.dispatch("LineasCredito/getTiposCredito");
          }
        }
      );
    },
    softDeleteLineaCredito(id) {
      let datos = { Id: id };
      this.$alert.alertConfirm(
        {
          action:"Eliminar",
          obj:"el tipo linea de crédito",
          route:'BNK-TiposLineaCredito-deleteTipoLineaCredito',
          data:datos,
          onSuccess:()=>{
            
            this.$store.dispatch("LineasCredito/getTiposCredito");
            this.$forceUpdate();
          }
        }
      );
    },
    toggleModal(open) {
      this.Dialogs.showModal = open;
    },
  },
  beforeMount: function () {},
  mounted: async function () {
    this.$store.dispatch("LineasCredito/getTiposCredito");
  },
};
</script>